import * as types from './actionTypes/loan-applications';
import loanApplicationsAPI from '../../data/loan-applications-api';
import { endLoading, startLoading } from './loading-actions';
import BaseApi from '../../data/base-api';
import QDApplicationModel_ from '../../data/models/QDApplicationModel';
import ResponseBase_ from '../../data/models/ResponseBase';
import LoanApplicationHistory_ from '../../data/models/LoanApplicationHistory';

export interface IActiveQDModelsActionType {
  type: typeof types.GET_ACTIVE_QD_MODELS_SUCCESS | typeof types.GET_ACTIVE_QD_MODELS_FAIL;
  payload: ResponseBase_<QDApplicationModel_[]>;
}

export interface IEvaluatedQDModelsActionType {
  type: typeof types.GET_EVALUATED_QD_MODELS_SUCCESS | typeof types.GET_EVALUATED_QD_MODELS_FAIL;
  payload: ResponseBase_<QDApplicationModel_[]>;
}

export interface ILoadApplicationHistoryActionType {
  type: typeof types.GET_LOAN_APPLICATION_HISTORY_SUCCESS | typeof types.GET_LOAN_APPLICATION_HISTORY_FAIL;
  payload: LoanApplicationHistory_[];
}

function getEvaluatedQDModelsSuccess(data: ResponseBase_<QDApplicationModel_[]>) {
  return { type: types.GET_EVALUATED_QD_MODELS_SUCCESS, payload: data, };
}
function getEvaluatedQDModelsFail(error: string) {
  return { type: types.GET_EVALUATED_QD_MODELS_FAIL, payload: error, error: true, };
}
export const getEvaluatedQDModels = (customerType) => async dispatch => {
  dispatch(startLoading());

  try {
    const result = await loanApplicationsAPI.getEvaluatedQDModels(customerType);
    return result.errorCode > 0
      ? dispatch(getEvaluatedQDModelsFail(result.message))
      : dispatch(getEvaluatedQDModelsSuccess(result));
  } catch (ex) {
    BaseApi.onError(ex);
  } finally {
    dispatch(endLoading());
  }
  return { };
};

function getLoanApplicationsHistorySuccess(data: LoanApplicationHistory_[]) {
  return { type: types.GET_LOAN_APPLICATION_HISTORY_SUCCESS, payload: data, };
}
function getLoanApplicationsHistoryFail(error: string) {
  return { type: types.GET_LOAN_APPLICATION_HISTORY_FAIL, payload: error, };
}
export const getLoanApplicationsHistory = () => async dispatch => {
  dispatch(startLoading());

  try {
    const { errorCode, message, result, } = await loanApplicationsAPI.getLoanApplicationsHistory();
    dispatch(endLoading());

    return errorCode > 0
      ? dispatch(getLoanApplicationsHistoryFail(message))
      : dispatch(getLoanApplicationsHistorySuccess(result));
  } catch (ex) {
    dispatch(endLoading());
    BaseApi.onError(ex);
  }
  return { };
};
